export default "__VITE_ASSET__ba7d0757__"